
// USP section swiper
const uspSection = document.getElementById('iclicks-usp-section');
if (uspSection) {
    const swc = uspSection.querySelector(".swiper-uspSection");
    if (swc) {
        swc.style.maxHeight = uspSection.offsetHeight + "px";
        var swiper = new Swiper('.swiper-uspSection', {
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 3000
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {  
            '530': {
                slidesPerView: 2,
            },
            '768': {
                slidesPerView: 3,
            },
            },
        });
    }
}

// Sticky button

   document.addEventListener('DOMContentLoaded', function() {
       var btnFilter = document.querySelector('.toolbar-products');

      // Function to add or remove the class based on scroll position
      function toggleScrolledClass() {
        if (btnFilter) {
        var rect = btnFilter.getBoundingClientRect();
       
        var currentScroll = window.scrollY || document.documentElement.scrollTop;
        if (currentScroll >= (rect.top + rect.height)) {
          btnFilter.classList.add('scrolled');
        } else {
          btnFilter.classList.remove('scrolled');
        }
           }
      }

      // Initial call to set the initial state
      toggleScrolledClass();

      // Add scroll event listener
      window.addEventListener('scroll', function() {
        toggleScrolledClass();
      });
    });

document.addEventListener("DOMContentLoaded", function() {
 var faqQuestions = document.querySelectorAll(".faq-question");
    var faqAnswers = document.querySelectorAll(".faq-answer");

    faqQuestions.forEach(function(question) {
        question.nextElementSibling.style.maxHeight = "0";
        question.classList.add("closed", "toggle");

        question.addEventListener("click", function() {
            // Close other answers
            faqAnswers.forEach(function(answer) {
                if (answer !== question.nextElementSibling) {
                    answer.style.maxHeight = "0";
                }
            });

            this.classList.toggle("open");
            this.classList.toggle("closed");
            var answer = this.nextElementSibling;
            slideToggle(answer);
        });
    });


    function slideToggle(element) {
        if (element.style.maxHeight === "0px") {
            element.style.maxHeight = element.scrollHeight + 16 + "px";
        } else {
            element.style.maxHeight = "0";
        }
    }
});

    const comparisonWrap = document.querySelector('.comparison-wrap');
if (comparisonWrap) {
    let isDown = false;
    let startX;
    let scrollLeft;

    comparisonWrap.addEventListener('mousedown', (e) => {
        isDown = true;
        comparisonWrap.classList.add('active'); // Optional: Add a class to change the cursor when dragging
        startX = e.pageX - comparisonWrap.offsetLeft;
        scrollLeft = comparisonWrap.scrollLeft;
    });

    comparisonWrap.addEventListener('mouseleave', () => {
        isDown = false;
        comparisonWrap.classList.remove('active');
    });

    comparisonWrap.addEventListener('mouseup', () => {
        isDown = false;
        comparisonWrap.classList.remove('active');
    });

    comparisonWrap.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - comparisonWrap.offsetLeft;
        const walk = (x - startX) * 3; // Adjust the scrolling speed by changing the multiplier
        comparisonWrap.scrollLeft = scrollLeft - walk;
    });
 }
// (document).ready(function() {
//     // Define the max character count threshold
//     var maxCharacterLimit = 10; // Set this to your desired character limit

//     // Iterate over each `.swiper-wrapper`
//     jQuery('.swiper-wrapper').each(function() {
//         var $wrapper = $(this);
//         var maxHeight = 0;
        
//         // Iterate over all heading elements within the current swiper-wrapper
//         $wrapper.find('h1, h2, h3, h4, h5, h6').each(function() {
//             var $heading = $(this);
//             var headingText = $heading.text();

//             // Check if the text length exceeds the character limit
//             if (headingText.length > maxCharacterLimit) {
//                 // If it exceeds, find its height and keep track of the maximum height
//                 var headingHeight = $heading.outerHeight();
//                 if (headingHeight > maxHeight) {
//                     maxHeight = headingHeight;
//                 }
//             }
//         });

//         // Apply the max height to all heading elements within the same swiper-wrapper
//         if (maxHeight > 0) {
//             $wrapper.find('h1, h2, h3, h4, h5, h6').css('min-height', maxHeight + 'px');
//         }
//     });
// });
document.addEventListener('DOMContentLoaded', function () {
    var maxHeight = 200; // Maximum height for collapsed view
    var elements = document.querySelectorAll('.bls__banner-text--des'); // Select all elements

    // Language-specific Read More and Read Less text
    var translations = {
        'en': { readMore: "Read More", readLess: "Read Less" },
        'de': { readMore: "Mehr Lesen", readLess: "Weniger Lesen" },
        'fr': { readMore: "Lire la suite", readLess: "Lire moins" },
        'es': { readMore: "Leer más", readLess: "Leer menos" },
        'nl': { readMore: "Lees Meer", readLess: "Lees Minder" }
    };

    // Detect the language of the current page (using the lang attribute of the <html> tag)
    var lang = document.documentElement.lang || 'en'; // Default to English if language not set
    var translation = translations[lang] || translations['en']; // Fallback to English

    function applyHeightCollapseToElement(bannerTextElement) {
        var elementHeight = bannerTextElement.scrollHeight; // Get the full height of the content
        var isExpanded = bannerTextElement.classList.contains('open'); // Check if element is expanded based on existing class

        // Check if a Read More link already exists
        var existingLink = bannerTextElement.nextElementSibling;
        if (existingLink && existingLink.classList.contains('read-more-toggle')) {
            return; // Do nothing if the link already exists
        }

        if (elementHeight > maxHeight) {
            // Create the Read More link
            var readMoreLink = document.createElement('a');
            readMoreLink.href = "javascript:void(0);";
            readMoreLink.classList.add('read-more-toggle');
            readMoreLink.classList.add('collapsed');
            readMoreLink.innerText = translation.readMore;

            // Initially collapse the content by setting max-height and hiding overflow
            bannerTextElement.style.maxHeight = maxHeight + 'px';
            bannerTextElement.style.overflow = 'hidden';
            bannerTextElement.classList.add('collapsed');

            // Append the "Read More" link after the banner text element
            bannerTextElement.parentNode.appendChild(readMoreLink);

            // Toggle between expanded and collapsed view
            readMoreLink.addEventListener('click', function () {
                if (isExpanded) {
                    // Collapse the content
                    bannerTextElement.style.maxHeight = maxHeight + 'px';
                    bannerTextElement.style.overflow = 'hidden';
                    readMoreLink.innerText = translation.readMore;
                    readMoreLink.classList.remove('open');
                    readMoreLink.classList.add('collapsed');
                    bannerTextElement.classList.remove('open');
                    bannerTextElement.classList.add('collapsed');
                } else {
                    // Expand the content to its full height
                    bannerTextElement.style.maxHeight = elementHeight + 'px';
                    bannerTextElement.style.overflow = 'visible';
                    readMoreLink.innerText = translation.readLess;
                    bannerTextElement.classList.add('open');
                    bannerTextElement.classList.remove('collapsed');
                    readMoreLink.classList.add('open');
                    readMoreLink.classList.remove('collapsed');
                }
                isExpanded = !isExpanded; // Toggle the expanded state
            });
        }
    }

    function applyHeightCollapse() {
        if (window.innerWidth < 768) {
            elements.forEach(function (bannerTextElement) {
                applyHeightCollapseToElement(bannerTextElement);
            });
        }
    }

    // Run the height-based truncation logic on initial load
    applyHeightCollapse();

    // Run the truncation logic on window resize
    window.addEventListener('resize', function () {
        elements.forEach(function (bannerTextElement) {
            bannerTextElement.style.maxHeight = ''; // Reset max-height
            bannerTextElement.style.overflow = '';  // Reset overflow
            bannerTextElement.classList.remove('open', 'collapsed'); // Remove any previously added classes
        });
        applyHeightCollapse(); // Reapply the logic
    });
});






